import smsIsSentAlertDictionary from '@widgets/sms-is-sent-alert/i18n/ru/sms-is-sent-alert.dic.json';

export const smsIsSentAlert = {
  SMS_IS_SENT_ALERT: smsIsSentAlertDictionary,
};

export const smsIsSentAlertNamespaces = Object.keys(smsIsSentAlert);
